import React from 'react';
import { withTranslation } from '../../lib/translate';
import { IonButton } from '@ionic/react';
import Keyboard from 'react-simple-keyboard';
import Modal from '../modal';
import Basket from '../../lib/basket';
import { Spacer, Title } from '../common';
import './index.css';

class TableNumberModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableNumber: null,
      modalOpen: true,
    };
  }
  onChange = (val) => {
    this.setState({ tableNumber: val == '' ? null : val });
  };
  render() {
    const { __ } = this.props;
    const { tableNumber, modalOpen } = this.state;
    return (
      <Modal className="table-number-modal" isOpen={modalOpen} backdropDismiss={false}>
        <div>
          <div style={{ textAlign: 'center', borderBottom: '1px solid var(--ion-color-primary)' }}>
            <Title style={{ fontSize: '50px' }}>{tableNumber ?? __('Enter table number')}</Title>
          </div>

          <Spacer size={2} />

          <Keyboard
            layout={{
              default: ['1 2 3', '4 5 6', '7 8 9', ' 0 ', '{bksp}'],
            }}
            display={{
              '{bksp}': __('Delete'),
            }}
            maxLength={6}
            onChange={this.onChange}
          />
          <Spacer size={2} />
          <IonButton
            className="large-button"
            disabled={!tableNumber}
            expand="block"
            onClick={() => {
              this.setState({ modalOpen: false }, () => Basket.setTableNumber(tableNumber));
            }}
          >
            {__('Continue')}
          </IonButton>
        </div>
      </Modal>
    );
  }
}

export default withTranslation(TableNumberModal);
